const initServiceWorker = () => {
      if ("serviceWorker" in navigator) {
        window.addEventListener("load", () => {
          navigator.serviceWorker.getRegistrations().then((registration) => {
            if (!registration.active) {
              navigator.serviceWorker
                .register("/sw.js")
                .then((registration) => {
                  // Registration was successful
                  console.debug(
                    "ServiceWorker registration successful with scope: ",
                    registration.scope
                  );
                })
                .catch((err) => {
                  console.debug("ServiceWorker registration failed: ", err);
                });
            }
          });
        });
      } else {
        console.debug("no serviceWorker");
      }
}

export default initServiceWorker;


// WEBPACK FOOTER //
// ./src/serviceWorkerInit.js